import React from 'react';
import useModal from '../hooks/useModal';
import LoginModal from './LoginModal';
import SignupModal from './SignupModal';

const FrontPage = () => {
  const login = useModal();
  const signup = useModal();

  return (
    <div className="front-page">
      <section className="section talent-section">
        <h1>Talents</h1>
        <p>Gain access to opportunities to perform and represent.</p>
        <button onClick={signup.openModal}>Sign Up</button>
      </section>

      <section className="section brand-section">
        <h1>Brands</h1>
        <p>Achieve greatness with our media, creatives, and brand ambassadors.</p>
        <button onClick={login.openModal}>Login</button>
      </section>

      <LoginModal isOpen={login.isOpen} onClose={login.closeModal} />
      <SignupModal isOpen={signup.isOpen} onClose={signup.closeModal} />
    </div>
  );
};

export default FrontPage;
